import React from 'react';
import Tag from '@hero/ui-kit/components/Tag';
import type { BlastStatus } from '../../types';
const STATUS_TAG: Record<
    BlastStatus,
    {
        type: 'primary' | 'warn' | 'fail' | 'success';
        label: string;
    }
> = {
    DRAFT: { type: 'primary', label: 'Draft' },
    SCHEDULED: { type: 'warn', label: 'Scheduled' },
    SENDING: { type: 'primary', label: 'Sending' },
    CANCELLING: { type: 'warn', label: 'Cancelling' },
    COMPLETED: { type: 'success', label: 'Completed' },
    CANCELLED: { type: 'fail', label: 'Cancelled' },
    FAILED: { type: 'fail', label: 'Failed' }
};
type Props = {
    status: BlastStatus;
};
const BlastStatusPill: React.FC<Props> = ({ status }) => {
    const config = STATUS_TAG[status] ?? { type: 'primary' as const, label: status };
    return (
        <Tag type={config.type} size="small">
            {config.label}
        </Tag>
    );
};
export default BlastStatusPill;
